<div
  class="dialog-heading d-flex align-items-center justify-content-between px-4 py-3"
>
  <h1 class="text-xl fw-600 mb-0">
    Filter
    <ng-container *ngIf="appliedFilterCount"
      >({{ appliedFilterCount }})</ng-container
    >
  </h1>

  <button class="button-no-style" mat-dialog-close>
    <span
      class="cross-icon d-inline-block"
      [innerHTML]="crossBlackSVG | safeHTML"
    ></span>
  </button>
</div>

<mat-dialog-content>
  <form [formGroup]="filterForm">
    <div class="position-relative my-3" *ngIf="dialogData?.config?.visibility">
      <ng-container
        *ngTemplateOutlet="resetFilter; context: { controlName: 'visibility' }"
      ></ng-container>

      <app-dropdown-input
        label="Visibility"
        bindLabel="label"
        bindValue="value"
        [multiple]="true"
        [list]="visibility"
        [control]="$formControl(filterForm.get('visibility')!)"
      ></app-dropdown-input>
    </div>

    <div class="position-relative my-3" *ngIf="dialogData?.config?.category">
      <ng-container
        *ngTemplateOutlet="resetFilter; context: { controlName: 'category' }"
      ></ng-container>

      <app-dropdown-input
        label="Category"
        bindLabel="label"
        bindValue="value"
        [multiple]="true"
        [list]="category"
        [control]="$formControl(filterForm.get('category')!)"
      ></app-dropdown-input>
    </div>

    <div
      class="position-relative my-3"
      *ngIf="dialogData?.config?.artifactType"
    >
      <ng-container
        *ngTemplateOutlet="
          resetFilter;
          context: { controlName: 'artifactType' }
        "
      ></ng-container>

      <app-dropdown-input
        label="Artefact Type"
        bindLabel="label"
        bindValue="value"
        [multiple]="true"
        [list]="artifactType"
        [control]="$formControl(filterForm.get('artifactType')!)"
      ></app-dropdown-input>
    </div>

    <div class="position-relative my-3" *ngIf="dialogData?.config?.requestedBy">
      <ng-container
        *ngTemplateOutlet="resetFilter; context: { controlName: 'requestedBy' }"
      ></ng-container>

      <app-dropdown-input
        label="Requested By"
        bindLabel="label"
        bindValue="value"
        [multiple]="true"
        [list]="requestedBy"
        [control]="$formControl(filterForm.get('requestedBy')!)"
      ></app-dropdown-input>
    </div>

    <div
      class="position-relative my-3"
      *ngIf="dialogData?.config?.organizationType"
    >
      <ng-container
        *ngTemplateOutlet="
          resetFilter;
          context: { controlName: 'organizationType' }
        "
      ></ng-container>

      <app-dropdown-input
        label="OrganizationType"
        bindLabel="label"
        bindValue="value"
        [multiple]="true"
        [list]="organizationType"
        [control]="$formControl(filterForm.get('organizationType')!)"
      ></app-dropdown-input>
    </div>

    <div
      class="position-relative my-3"
      *ngIf="dialogData?.config?.sourceOrganization"
    >
      <ng-container
        *ngTemplateOutlet="
          resetFilter;
          context: { controlName: 'sourceOrganization' }
        "
      ></ng-container>

      <app-dropdown-input
        label="Source Organization"
        bindLabel="label"
        bindValue="value"
        [multiple]="true"
        [list]="sourceOrganization"
        [control]="$formControl(filterForm.get('sourceOrganization')!)"
      ></app-dropdown-input>
    </div>

    <div class="position-relative my-3" *ngIf="dialogData?.config?.sectors">
      <ng-container
        *ngTemplateOutlet="resetFilter; context: { controlName: 'sector' }"
      ></ng-container>

      <app-dropdown-input
        label="Sectors"
        bindLabel="label"
        bindValue="value"
        [multiple]="true"
        [list]="sector"
        [control]="$formControl(filterForm.get('sector')!)"
      ></app-dropdown-input>
    </div>

    <!--user type-->
    <div class="position-relative my-3" *ngIf="dialogData?.config?.userType">
      <ng-container
        *ngTemplateOutlet="resetFilter; context: { controlName: 'userType' }"
      ></ng-container>

      <app-dropdown-input
        label="User Type"
        bindLabel="label"
        bindValue="value"
        [multiple]="true"
        [list]="userTypeList"
        [control]="$formControl(filterForm.get('userType')!)"
      ></app-dropdown-input>
    </div>

    <div class="mb-3 my-3" *ngIf="dialogData?.config?.uploadedOn">
      <app-input-label label="Upload Date"></app-input-label>

      <div class="d-flex gap-2 mt-2">
        <button
          [ngClass]="{
            active:
              filterForm.controls['dateFilterType'].value === ActionDate.weekly
          }"
          class="chip active"
          (click)="setActionDate(ActionDate.weekly)"
        >
          {{ actionDateLabels["weekly"] }}
        </button>
        <button
          [ngClass]="{
            active:
              filterForm.controls['dateFilterType'].value === ActionDate.monthly
          }"
          class="chip"
          (click)="setActionDate(ActionDate.monthly)"
        >
          {{ actionDateLabels["monthly"] }}
        </button>
        <button
          [ngClass]="{
            active:
              filterForm.controls['dateFilterType'].value === ActionDate.custom
          }"
          class="chip"
          (click)="setActionDate(ActionDate.custom)"
        >
          {{ actionDateLabels["custom"] }}
        </button>
      </div>
    </div>

    <ng-container
      *ngIf="filterForm.controls['dateFilterType'].value === ActionDate.custom"
    >
      <app-date-range-input
        label="Custom Date"
        [isRequired]="true"
        [startDateControl]="$formControl(customDateRange.get('fromDate')!)"
        [endDateControl]="$formControl(customDateRange.get('toDate')!)"
      ></app-date-range-input>
    </ng-container>

    <ng-template let-controlName="controlName" #resetFilter>
      <span
        class="reset-control text-sm text-primary fw-500 cursor-pointer position-absolute"
        (click)="this.filterForm.get(controlName)?.reset()"
        >Reset</span
      >
    </ng-template>
  </form>
</mat-dialog-content>

<mat-dialog-content align="end" class="pt-1">
  <button
    class="text-black fw-500 btn btn-bordered-gray mb-0"
    (click)="onClearFilters()"
  >
    Clear All
  </button>
  <button
    class="fw-500 btn btn-secondary ms-2 apply-btn"
    (click)="onApplyFilters()"
  >
    Apply All
  </button>
</mat-dialog-content>
